import { CreateTournamentTemplateData, UpdateTournamentTemplateData } from '@repo/common-types';
import {
  createTournamentTemplateRest,
  getTournamentTemplatesRest,
  updateTournamentTemplateRest,
} from '@/services/tournaments/tournaments-service';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const useTournamentTemplates = ({ sng }: { sng?: boolean } = {}) => {
  const queryClient = useQueryClient();

  const { data: tournamentTemplates, refetch: refetchTournamentTemplates } = useQuery({
    queryKey: ['tournamentTemplates', { sng: sng }],
    queryFn: () => getTournamentTemplatesRest(sng),
    staleTime: 60000,
  });

  const { mutate: createTournamentTemplate } = useMutation({
    mutationFn: (tournamentTemplate: CreateTournamentTemplateData) => createTournamentTemplateRest(tournamentTemplate),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tournamentTemplates'] });
    },
  });

  const { mutate: updateTournamentTemplate } = useMutation({
    mutationFn: (tournamentTemplate: UpdateTournamentTemplateData & { id: string }) =>
      updateTournamentTemplateRest(tournamentTemplate),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['tournamentTemplates'] });
    },
  });

  return {
    tournamentTemplates,
    refetchTournamentTemplates,
    createTournamentTemplate,
    updateTournamentTemplate,
  };
};

export default useTournamentTemplates;
